import {
  AdditionalServicesAvailability,
  LoyaltyDiscount,
} from '@notino/web-tracking';

import {
  runTrackingEventViewItem,
  runExponeaFunctions,
} from '@containers/App/utils';
import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';

import {
  getProductView_productDetailByMasterId_variants,
  getProductView_productDetailByMasterId,
} from '../queries/__generated__/getProductView';
import {
  productDetailViewFragment,
  productDetailViewFragment_variants,
} from '../queries/__generated__/productDetailViewFragment';

import {
  RRP_PRICE_PROMO_LABEL,
  MIN_PRICE_PROMO_LABEL,
} from './hooks/usePriceLogic/tracking';
import { IModifaceEffectVariants } from './ModiFaceModal/model';

interface ITrackPageReloadParams {
  hasWebcam?: boolean;
  variant: getProductView_productDetailByMasterId_variants;
  product: getProductView_productDetailByMasterId;
  modifaceVariants: IModifaceEffectVariants;
  engravingAvailable: AdditionalServicesAvailability;
  tryItFirstAvailable: AdditionalServicesAvailability;
  giftAvailable: boolean;
  loyaltyDiscount?: LoyaltyDiscount;
  rrpShown: boolean;
  minimalPriceShown: boolean;
}
export const trackPageReload = ({
  variant,
  product,
  modifaceVariants = {},
  engravingAvailable,
  tryItFirstAvailable,
  giftAvailable,
  loyaltyDiscount,
  hasWebcam,
  rrpShown,
  minimalPriceShown,
}: ITrackPageReloadParams) => {
  dispatchTrackingEvent({
    event: 'view_item',
    products: [
      ProductEventWither()
        .withProduct(product)
        .withVariant(variant)
        .withAdditionalPromoLabels([
          rrpShown && RRP_PRICE_PROMO_LABEL,
          minimalPriceShown && MIN_PRICE_PROMO_LABEL,
        ])
        .withServices({
          engravingAvailable,
          tryItFirstAvailable,
          modifaceVariants,
          loyaltyDiscount,
          giftAvailable,
          hasWebcam,
          shadefinderAvailable: product.isShadeFinderAvailable,
        })
        .build(),
    ],
    _clear: true,
  });
};

export const trackItemInExponea = (
  product: productDetailViewFragment,
  variant: productDetailViewFragment_variants
) => {
  runTrackingEventViewItem({
    id: variant.id,
    name: variant.name,
    code: variant.productCode,
    masterProductCode: product.code,
    brandName: product.brandInfo.name,
    gender: variant.gender,
    marketType: product.marketType,
    price: variant.price.value,
    kind: product.kind,
    categories: product.category,
    subcategories: product.subCategory,
    types: product.type,
    stockQuantity: variant.stockAvailability.code,
    attributes: variant.attributes,
  });
  runExponeaFunctions();
};
